import {Injectable} from '@angular/core';
import {APIService} from "./api.service";
import {Observable} from "rxjs";
import {ICharityPayout} from "../interfaces/charity/ICharityPayout";
import {ICharityBalance} from "../interfaces/charity/ICharityBalance";
import {ICharityPayoutNote} from "../interfaces/charity/ICharityPayoutNote";
import {IUpdateCharityPayoutCommand} from "../interfaces/commands/IUpdateCharityPayoutCommand";
import {ICreateCharityPayoutNoteCommand} from "../interfaces/commands/ICreateCharityPayoutNoteCommand";
import {ICreateCharityPayoutNoteResponse} from "../interfaces/responses/ICreateCharityPayoutNoteResponse";
import {IUpdateCharityPayoutPayload} from "../interfaces/commands/IUpdateCharityPayoutPayload";

@Injectable({
  providedIn: 'root'
})
export class CharityPayoutService {

  constructor(private apiService: APIService) {
  }

  public fetchCharityPayoutsByCharityId(charityIdP: string, gameIdP?: string): Observable<ICharityPayout[]> {
    const queryParams = gameIdP ? `?GameId=${gameIdP}` : '';
    return this.apiService.MakeGetRequest<ICharityPayout[]>(`charity-payout/by-charity/${charityIdP}${queryParams}`);
  }

  public fetchBalancesByGameId(gameIdP: string): Observable<ICharityBalance[]> {
    return this.apiService.MakeGetRequest<ICharityBalance[]>(`charity-payout/balances-by-game/${gameIdP}`);
  }

  public fetchBalanceByCharityId(charityIdP: string, gameIdP?: string): Observable<ICharityBalance> {
    const queryParams = gameIdP ? `?GameId=${gameIdP}` : '';
    return this.apiService.MakeGetRequest<ICharityBalance>(`charity-payout/balance/${charityIdP}${queryParams}`);
  }

  public fetchNotesByCharityPayoutId(charityPayoutIdP: string, gameIdP?: string): Observable<ICharityPayoutNote[]> {
    const queryParams = gameIdP ? `?GameId=${gameIdP}` : '';
    return this.apiService.MakeGetRequest<ICharityPayoutNote[]>(`charity-payout/${charityPayoutIdP}/notes${queryParams}`);
  }

  public createCharityPayoutNote(command: ICreateCharityPayoutNoteCommand): Observable<ICreateCharityPayoutNoteResponse> {
    return this.apiService.MakePostRequest<ICreateCharityPayoutNoteResponse>('charity-payout/notes', command);
  }

  public updateCharityPayout(command: IUpdateCharityPayoutCommand): Observable<void> {
    const payload: IUpdateCharityPayoutPayload = {
      PayoutAmount: command.PayoutAmount,
      Note: command.Note,
      GameId: command.GameId,
      CharityPayoutId: command.CharityPayoutId
    };
    return this.apiService.MakePutRequest<void>(`charity-payout`, payload);
  }
}
